import type {GroupConfiguration} from './group-configuration-table';

export const canMoveLeft = (
    groupConfigurationIndex: number,
    groupConfigurations: GroupConfiguration[]
): boolean => {
    return (
        // @ts-expect-error
        !groupConfigurations[groupConfigurationIndex].isFixed && // element is not fixed
        groupConfigurationIndex > 0 && // not the first element
        // @ts-expect-error
        !groupConfigurations[groupConfigurationIndex - 1].isFixed // element to the left is not fixed
    );
};

export const canMoveRight = (
    groupConfigurationIndex: number,
    groupConfigurations: GroupConfiguration[]
): boolean => {
    return (
        // @ts-expect-error
        !groupConfigurations[groupConfigurationIndex].isFixed && // element is not fixed
        groupConfigurationIndex < groupConfigurations.length - 1 && // not the last element
        // @ts-expect-error
        !groupConfigurations[groupConfigurationIndex + 1].isFixed // element to the right is not fixed
    );
};
